import * as S from "./CommentList.style";
import { AlertText } from "@/components/atoms/AlertText";
import { CommentItem } from "@/components/atoms/CommentItem";
import { StudentCheerMessage } from "@/common/types/cheerMessage";

interface CommentListProps {
  data?: StudentCheerMessage[];
}

export const CommentList = ({ data }: CommentListProps) => {
  return (
    <S.CommentList>
      {data && (
        <>
          {data?.map((item: any, idx: number) => {
            return <CommentItem data={item} key={idx} />;
          })}
        </>
      )}

      {!data && <AlertText subText="응원 메시지 내역이 없습니다." />}
    </S.CommentList>
  );
};
